export default "__VITE_ASSET__xLODyuLh__"